import { HttpClient } from './client/httpClient';
import { ErrorHandler } from './error/errorHandler';
import backendHttpClient from './client/backendHttpClient';
import apiErrorHandler from './error/apiErrorHandler';
import { BearerboxModel } from '../models/bearerboxModel';
import { BearerboxStatusResponse, BearerboxStoreStatusResponse } from './responses/bearerboxResponse';
import { getCurrentTimestamp } from '../utils/datetimeUtils';

class BearerboxApi {
  constructor(private readonly httpClient: HttpClient,
              private readonly errorHandler: ErrorHandler) {}

  public fetchBearerbox(serverId: string): Promise<BearerboxModel> {
    return Promise.all([
      this.fetchBearerboxStatus(serverId),
      this.fetchBearerboxStoreStatus(serverId)
    ]).then(([statusRes, storeStatusRes]) => this.mapToBearerboxModel(serverId, statusRes, storeStatusRes))
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch full bearerbox status'));
  }

  private fetchBearerboxStatus(serverId: string): Promise<BearerboxStatusResponse> {
    return this.httpClient.get<BearerboxStatusResponse>(`/servers/${serverId}/bearerbox`);
  }

  private fetchBearerboxStoreStatus(serverId: string): Promise<BearerboxStoreStatusResponse> {
    return this.httpClient.get<BearerboxStoreStatusResponse>(`/servers/${serverId}/bearerbox-store`);
  }

  private mapToBearerboxModel(serverId: string,
                              statusResponse: BearerboxStatusResponse,
                              storeStatusResponse: BearerboxStoreStatusResponse): BearerboxModel {
    return {
      serverId,
      status: statusResponse,
      storeStatus: storeStatusResponse,
      fetchedAt: getCurrentTimestamp(),
    };
  }
}

export default new BearerboxApi(backendHttpClient, apiErrorHandler);
